"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxWidthStyled = void 0;
const Breakpoints_Styled_1 = require("./Breakpoints.Styled");
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const sizes = {
    lg: 1410,
    md: 1170,
    sm: 930,
    xs: 690,
};
const Grid = ({ grid = 1, rowGap = 1, columnGap = Math.min(grid || 1, 3), gridXs = 1, gridSm = Math.max(Math.round(grid || 1 / 2), 1), gridMd = Math.max(Math.round(grid || 1 / 2), 1), gridLg = grid || 1, gridXl = grid || 1, }) => Breakpoints_Styled_1.mq({
    display: 'grid',
    gridColumnGap: [
        0,
        `${columnGap / 2}rem`,
        `${columnGap / 2}rem`,
        `${columnGap}rem`,
    ],
    gridRowGap: `${rowGap}rem`,
    gridTemplateColumns: [
        `repeat(${gridXs}, minmax(0, 1fr))`,
        `repeat(${gridSm}, minmax(0, 1fr))`,
        `repeat(${gridMd}, minmax(0, 1fr))`,
        `repeat(${gridLg}, minmax(0, 1fr))`,
        `repeat(${gridXl}, minmax(0, 1fr))`,
    ],
});
const Flex = ({ align = 'center', col = false, flex }) => flex &&
    react_1.css `
    display: flex;
    flex-direction: ${col ? 'column' : 'row'};
    flex-wrap: wrap;
    justify-content: ${flex};
    align-items: ${align};
  `;
// eslint-disable-next-line import/prefer-default-export
exports.MaxWidthStyled = styled_1.default.div(({ padding, size = 'lg' }) => react_1.css `
    width: 100%;
    max-width: ${size === 'none'
    ? 'none'
    : `${sizes[size] + (padding === true ? 50 : (padding || 0) * 20)}px`};
    margin: 0 auto;
  `, Flex, (props) => props.grid && Grid(props), ({ padding }) => padding &&
    react_1.css `
      padding-right: ${padding === true ? 2.5 : padding}rem;
      padding-left: ${padding === true ? 2.5 : padding}rem;
    `);
